var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.4 20.5",
    style: {
      enableBackground: "new 0 0 20.4 20.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#788195;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.9,18.8L15.1,14c1.2-1.5,1.9-3.3,1.9-5.3c0-4.7-3.8-8.4-8.4-8.4C3.9,0.3,0.2,4,0.2,8.7s3.8,8.4,8.4,8.4 c2,0,3.9-0.7,5.3-1.9l4.8,4.8c0.3,0.3,0.9,0.3,1.2,0C20.3,19.7,20.3,19.2,19.9,18.8L19.9,18.8z M8.6,15.4c-3.7,0-6.8-3-6.8-6.8 s3-6.8,6.8-6.8c3.7,0,6.8,3,6.8,6.8S12.3,15.4,8.6,15.4L8.6,15.4z M8.6,15.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10Icon);
export default __webpack_public_path__ + "static/media/10-icon.2be1b2334af2bd98f70046b83f5a8dcf.svg";
export { ForwardRef as ReactComponent };